import { render } from "./edit.vue?vue&type=template&id=70bc4747"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/tester_types/edit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "70bc4747"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('70bc4747', __exports__)) {
    console.log('reload')
    api.reload('70bc4747', __exports__)
  }
  
  module.hot.accept("./edit.vue?vue&type=template&id=70bc4747", () => {
    console.log('re-render')
    api.rerender('70bc4747', render)
  })

}


export default __exports__